
/**
 *
 * File
 *
 */

import React from 'react';
import {
  Label,
  Input,
  ColorOpenerWrapper,
  StyledSecondButton,
  ColorContainer,
  SecondButtonText,
  OrText,
  Wrapper,
  LabelButton,
  ButtonGroup,
  UnstyledInput,
  FileWrapper,
  SelectIcon,
} from './styledComponents';

import InputValidator from 'components/InputValidator';
import Icon from 'components/Icon'
import { colors } from 'globalStyles';

// TODO: Refactor to ColorPickerButton and decouple from File component
class SecondButton extends React.PureComponent {
  render() {
    const { hasFirstButton, buttonText, onClick } = this.props;
    return (
      <Wrapper innerRef={ref => this.siblingRef = ref}>
        {hasFirstButton && <OrText>or Pick a Color:</OrText>}
        <StyledSecondButton
          onClick={() => onClick(this.siblingRef)}
          type='button'>
          <ColorContainer backgroundColor={buttonText} />
          <SecondButtonText>{buttonText}</SecondButtonText>
        </StyledSecondButton>
      </Wrapper>
    );
  }
}

const DropDownArrow = () => (
  <Icon
    size='10'
    name='drop-down'
  />
)

export class ColorPickerButton extends React.PureComponent {
  componentWillReceiveProps(props) {
    const { input: { onChange }, buttonText } = props;

    if (buttonText) {
      onChange(buttonText)
    }
  }

  componentDidMount() {
    const { input: { value, onChange }, buttonText } = this.props;

    if (!value && buttonText) {
      onChange(buttonText)
    }
  }

  render() {
    const { buttonText, onClick, label, disabled, colorPreviewOnLeft, placeholder, enableRemoveIcon,
      input: { onChange, ...input }
    } = this.props;
    const openPicker = () => !disabled && onClick({
      hex: buttonText,
      siblingRef: this.siblingRef,
      onChange,
      label
    });
    return (
      <Wrapper innerRef={ref => this.siblingRef = ref}>
        <Input
          className={`${colorPreviewOnLeft ? 'has-icon' : ''}`}
          {...input}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => e.target.value === '' ? onChange('') : onChange((e.target.value[0] === '#' ? '' : '#') + e.target.value.replace(/[^#0-9A-Za-z]/g, ''))}
        />
        <Label>
          {label}
        </Label>
        {colorPreviewOnLeft && (
          <ColorOpenerWrapper className='left' onClick={openPicker}>
            <ColorContainer backgroundColor={buttonText || colors.MENU} />
          </ColorOpenerWrapper>
        )}
        <ColorOpenerWrapper onClick={openPicker}>
          {!colorPreviewOnLeft && <ColorContainer backgroundColor={buttonText || colors.MENU} />}
        </ColorOpenerWrapper>
        {enableRemoveIcon && buttonText && (
          <SelectIcon
            className='right'
            onClick={() => onChange('')}>
            <Icon name='x' size='10' />
          </SelectIcon>
        )}
      </Wrapper>
    );
  }
}

class File extends React.PureComponent {
  state = {
    trickUploadSameFile: false
  }

  componentDidUpdate(prevProps) {
    const { input: { value } } = this.props;

    // Hack for upload same file
    if (prevProps.input.value !== value) {
      this.setState({ trickUploadSameFile: true }, () => {
        this.setState({ trickUploadSameFile: false })
      })
    }
  }

  customOnChange = (value) => {
    const { validateFnc, validateMsg, input } = this.props
    if (validateFnc) {
      const files = value.target.files;
      validateFnc(value)
        .then(() => input.onChange(files))
        .catch(() => {
          validateMsg && alert(validateMsg);
          this.setState({ trickUploadSameFile: true }, () => {
            this.setState({ trickUploadSameFile: false })
          })
        });
    }
    else {
      input.onChange(value)
    }
  }

  render() {
    const {
      input: { value, ...inputProps },
      label,
      meta: { error, valid },
      accept,
      className,
      children,
      inputClassName,
      labelClassName,
      iconOffset,
      validIconName,
      errorIconName,
      emptyIconName,
      buttonText,
      secondButtonProps,
      height,
      labelMarginLeft,
      showButton
    } = this.props;
    const hasError = error, isValid = value && valid;
    const labelMarginTop = -1 * (height + 7);

    return (
      <Wrapper className={className}>
        <FileWrapper
          height={height}
          hasError={hasError}
          className={inputClassName}>
          {children}
          {showButton && (
          <ButtonGroup hasButtonText={!!buttonText}>
            {buttonText &&
              <LabelButton>
                {!this.state.trickUploadSameFile && <UnstyledInput
                  {...inputProps}
                  onChange={this.customOnChange}
                  type='file'
                  accept={accept}
                  hidden
                />}
                {buttonText}
              </LabelButton>
            }
            {secondButtonProps &&
              <SecondButton
                hasFirstButton={!!buttonText}
                onChange={this.customOnChange}
                {...secondButtonProps}
              />
            }
          </ButtonGroup>
          )}
        </FileWrapper>
        <Label
          marginTop={labelMarginTop}
          marginLeft={labelMarginLeft}
          className={labelClassName}>
          {label}
        </Label>
        <InputValidator
          isValid={isValid}
          hasError={hasError}
          offset={iconOffset}
          validIconName={validIconName}
          errorIconName={errorIconName}
          emptyIconName={emptyIconName}
        />

        <Icon
          className='drop-down-arrow'
          size='6'
          name='drop-down-arrow'
        />
      </Wrapper>
    );

  }
}

export default File;



// WEBPACK FOOTER //
// ./src/components/InputField/File.js